import { render, staticRenderFns } from "./RedemptionDetailItem.vue?vue&type=template&id=5ff175b0"
import script from "./RedemptionDetailItem.vue?vue&type=script&lang=js"
export * from "./RedemptionDetailItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports